module.exports = __webpack_public_path__ + "static/media/pin-outlined-gray.546e9736.svg";